import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

export const HamburgerMenuIcon = forwardRef<SVGSVGElement, IconClientSVGProps>(
  ({ label, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={ref}
        >
          <path d="M0 0.5H16M0 15.5H16M0 8H16" stroke="currentColor" />
        </svg>
      </Icon>
    );
  },
);

HamburgerMenuIcon.displayName = "HamburgerMenuIcon";
